import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiSupportService } from '@fi-shared/fi-support/fi-support.service';

@Component({
    selector: 'fi-support',
    template: `
        <button mat-icon-button (click)="checkOpenContactSupport()">
            <span class="fa fa-question-circle BrandedColor" aria-hidden="true"></span>
        </button>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fi-support.component.scss'],
    host: { class: 'fi-support' },
    standalone: false,
})
export class FiSupportComponent {
    constructor(
        private fiCustomerDataService: FiCustomerDataService,
        private supportService: FiSupportService,
    ) {}

    checkOpenContactSupport() {
        this.supportService.checkOpenContactSupport();
    }
}
